import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email.trim(), password.trim()); nav("/admin"); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-admbg flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-admcard border border-admborder mb-4"><span className="font-serif font-bold text-2xl text-admtext">TFD</span></div>
          <h1 className="font-serif text-3xl text-admtext">The Fin Desk</h1>
          <p className="text-admtext2 text-xs uppercase tracking-[0.2em] mt-1">Editorial Console</p>
        </div>
        <form onSubmit={submit} className="bg-admcard border border-admborder p-6 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-admtext2 mb-1 block">Username</label>
            <input type="text" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
              className="w-full bg-admbg border border-admborder px-3 py-2.5 text-admtext text-sm outline-none focus:border-cyan" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-admtext2 mb-1 block">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
              className="w-full bg-admbg border border-admborder px-3 py-2.5 text-admtext text-sm outline-none focus:border-cyan" />
          </div>
          {error && <div className="text-crimson text-sm" data-testid="login-error">{error}</div>}
          <button disabled={loading} data-testid="login-submit"
            className="w-full bg-crimson hover:bg-crimsonhover text-white py-2.5 text-sm font-semibold uppercase tracking-wider transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
